<div>
  <ion-grid class="monorepo-form__items-container">
    <ion-row>
      <ng-container *ngFor="let inps of _liftedFormModel.inputs; let i = index; trackBy: trackByFn">
        <ng-container *ngIf="!inps.metadata.isHidden">
          <ion-col
            [size]="inps.input.type === 'TEXTAREA' ? 12 : colSize"
            class="monorepo-form__col"
            [ngClass]="{
              'monorepo-form__col--inline': inps.metadata.displayInputInline,
              'monorepo-form__col--inline-reversed': inps.metadata.displayInputInline && inps.metadata.checkboxFirst
            }"
          >
            <div class="monorepo-form__col-header">
              <span>{{ inps.metadata.label || inps.metadata.keyName | translate }}</span>
              <span *ngIf="inps.metadata.isRequired" class="monorepo-form__required-icon"> *</span>
            </div>

            <div *ngIf="inps.input.type === 'DROPDOWN'">
              <ion-select
                class="ion-text-left"
                interface="popover"
                [interfaceOptions]="interfaceOptions"
                [placeholder]="inps.input.placeholder || '' | translate"
                [value]="inps.input.value"
                [disabled]="inps.metadata.isDisabled"
                (ionChange)="onChange($event, inps, i)"
                [multiple]="inps.input.isMulti"
              >
                <ion-select-option *ngFor="let item of inps.input.options" [value]="item.value">
                  {{ item.displayName || item.value.toString() | translate }}
                </ion-select-option>
              </ion-select>
            </div>

            <div *ngIf="inps.input.type === 'DROPDOWN_WITH_SEARCH'">
              <monorepo-multi-select-dropdown
                [dropdownConfig]="{
                  isMultiSelect: inps.input.isMulti || false,
                  placeHolder: inps.input.placeholder,
                  isDisabled: inps.metadata.isDisabled || false,
                  isClearOption: inps.input.isClearOption || false
                }"
                [virtualScroll]="inps.input.virtualScroll"
                [dropdownData]="{ items: inps.input.options || [], defaultSelectedItems: inps.input.value }"
                (selectedList)="onDropdownListSelection($event, inps, i)"
              ></monorepo-multi-select-dropdown>
            </div>

            <div *ngIf="inps.input.type === 'INPUT'">
              <div class="monorepo-form__editable-input" *ngIf="!inps.metadata.isReadonly; else inputNonEditable">
                <ion-input
                  [id]="inps.metadata.keyName"
                  [type]="inps.input.subType"
                  [value]="inps.input.value"
                  [disabled]="inps.metadata.isDisabled"
                  [placeholder]="inps.input.placeholder || '' | translate"
                  (ionChange)="onChange($event, inps, i)"
                >
                </ion-input>
                <!-- <ng-container
                  [ngTemplateOutlet]="invalidMsg"
                  [ngTemplateOutletContext]="{
                    inps: inps
                  }"
                ></ng-container> -->
              </div>
              <ng-template #inputNonEditable>
                <div class="monorepo-form__non-editable-field">{{ inps.input.value }}</div>
              </ng-template>
            </div>

            <div *ngIf="inps.input.type === 'SEARCH'" class="monorepo-form__search-container">
              <ion-searchbar
                *ngIf="!inps.input.searchOnSearchTextClick; else searchOnSearchTextClick"
                [id]="inps.metadata.id"
                mode="ios"
                [value]="inps.input.value || inps.input.searchText"
                [disabled]="inps.metadata.isDisabled"
                placeholder="{{ inps.input.placeholder }}"
                [debounce]="inps.input.debounce"
                (keyup)="handleSearchEvent($event, inps, i)"
                (ionClear)="onClearSearchEvent(inps, i)"
              >
              </ion-searchbar>

              <ng-template #searchOnSearchTextClick>
                <div
                  class="monorepo-form__search-on-enter-container"
                  [ngClass]="{ 'monorepo-form__search-on-enter-container--disabled': inps.metadata.isDisabled }"
                >
                  <ion-input
                    #searchOnSearchTextClickInput
                    class="monorepo-form__search-input"
                    [id]="inps.metadata.id"
                    [value]="inps.input.value || inps.input.searchText"
                    [disabled]="inps.metadata.isDisabled || false"
                    placeholder="{{ inps.input.placeholder }}"
                    (ionInput)="onSearchInputChange($event, inps, i)"
                    (keyup.enter)="handleSearchEvent($event, inps, i)"
                  >
                  </ion-input>
                  <div class="monorepo-form__search-cross-container">
                    <span
                      *ngIf="!inps.input.value; else searchValuePresent"
                      class="monorepo-form__search-text"
                      (click)="handleSearchEvent($event, inps, i)"
                      >{{ 'form.Search' | translate }}</span
                    >

                    <ng-template #searchValuePresent>
                      <ion-icon
                        name="close-circle-outline"
                        class="monorepo-form__search-cross-icon"
                        (click)="onClearSearchEvent(inps, i)"
                      ></ion-icon>
                    </ng-template>
                  </div>
                </div>
              </ng-template>

              <div *ngIf="inps.input.searchResultsNotFound" class="monorepo-form__invalid-msg">
                {{ 'form.NoResults' | translate }}
              </div>
              <div
                *ngIf="inps.input.showSuggestions"
                (clickOutside)="handleOutsideClick(inps, i)"
                class="monorepo-form__suggestions-container"
              >
                <div
                  *ngFor="let items of inps.input.options"
                  (click)="onSuggestionSelection(items.value, inps, i)"
                  class="monorepo-form__suggestions-items"
                >
                  {{ items.value.toString() | translate }}
                </div>
              </div>
            </div>

            <div *ngIf="inps.input.type === 'TEXTAREA'">
              <ion-textarea
                [id]="inps.metadata.keyName"
                [value]="inps.input.value"
                [placeholder]="inps.input.placeholder"
                [rows]="inps.input.rows ?? 2"
                [maxlength]="inps.input.maxlength"
                [minlength]="inps.input.minlength"
                [disabled]="inps.metadata.isDisabled"
                [readonly]="inps.metadata.isReadonly"
                (ionChange)="onChange($event, inps, i)"
              >
              </ion-textarea>
              <div class="monorepo-form__textarea-limits" *ngIf="inps.input.maxlength || inps.input.minlength">
                <span>
                  {{ inps.input.value?.length ?? 0 }} / {{ inps.input.minlength ? inps.input.minlength + '-' : '' }}
                  {{ inps.input.maxlength ?? '∞' }}
                </span>
              </div>
            </div>

            <div *ngIf="inps.input.type === 'CHECKBOX'">
              <ion-checkbox
                [mode]="'ios'"
                [checked]="inps.input.checked"
                [disabled]="inps.input.disabled"
                (ionChange)="onChange($event, inps, i)"
              ></ion-checkbox>
            </div>
            <div *ngIf="showValidityError(inps)" class="monorepo-form__invalid-msg">
              <span> {{ 'form.ErrorMsg' | translate }} </span
              ><span>{{ inps.metadata.label || inps.metadata.keyName | translate }}</span>
            </div>
          </ion-col>

          <ion-col size="2" *ngIf="showGap(i)"></ion-col>
        </ng-container>
      </ng-container>
    </ion-row>
  </ion-grid>
</div>

<ng-template #invalidMsg let-inps="inps">
  <div *ngIf="showValidityError(inps)" class="monorepo-form__invalid-msg">
    <span> {{ 'form.ErrorMsg' | translate }} </span
    ><span>{{ inps.metadata.label || inps.metadata.keyName | translate }}</span>
  </div>
</ng-template>
